import React from 'react';
import { connect } from 'react-redux';
import TopSixList from 'components/Global/TopSixList/TopSixList.jsx';
import EntityItem from 'components/Global/EntityItem/EntityItem.jsx';
import { Title } from 'components/Global/StatCard/styled.js';
import { fetchTrendingBrands } from 'components/Pages/Home/actions.js';
import trendingIcon from 'images/icons/upwardTrend.svg';
import { TopDataOverlay, TopDataContainer } from './styled.js';
import { getImg } from './helpers.js';

const TrendingBrands = props => {
  const { trendingBrandsList, getTrendingBrands } = props;
  const { data } = trendingBrandsList;
  const bannerImageUrl = getImg(data, 0);

  return (
    <TopDataContainer bannerImageUrl={bannerImageUrl}>
      <TopDataOverlay>
        <TopSixList
          fetchStore={clear => getTrendingBrands(clear)}
          store={trendingBrandsList}
          titleIcon={trendingIcon}
          title={<Title titleIcon={trendingIcon}>Trending Brands</Title>}
          columns={2}
          width="100%"
        >
          <EntityItem />
        </TopSixList>
      </TopDataOverlay>
    </TopDataContainer>
  );
};

const mapStateToProps = ({ Home: { trendingBrandsList } }) => ({
  trendingBrandsList,
});

const mapDispatchToProps = dispatch => ({
  getTrendingBrands: clear => dispatch(fetchTrendingBrands(clear)),
});

export default connect(mapStateToProps, mapDispatchToProps)(TrendingBrands);
